import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import CollapsableBlockMobile from './CollapsableBlockMobile';
import Alert from '../../../common/Alert';

import UserSettingsForm from '../../../profile/blocks/settings/UserSettingsForm';

const UserSettingsBlockMobile = () => {
  const { user, token } = useSelector(state => state);
  const [status, setStatus] = useState({});

  return (
    <CollapsableBlockMobile header="Profile Settings">
      <div className="m-user-image-container">
        <img src="img/icons/user-big.svg" width={130} height={130} />
        <a className="user-image-download-link disabled">Download</a>
        <p className="user-image-text mt-20px">File size max: 2Mb. Recommended foto size: 200x200 px</p>
      </div>

      {(status.isSuccess || status.isError) && (
        <div className="mt-10px">
          <Alert
            message={status.message}
            isSuccess={status.isSuccess}
            isError={status.isError}
            isSmall
            isClosable={true}
          />
        </div>
      )}
      <UserSettingsForm
        user={user}
        token={token}
        onStatusChanged={setStatus}
        className="is-fullwidth mt-15px"
        isMobile
      />
    </CollapsableBlockMobile>
  );
};

export default UserSettingsBlockMobile;
